import { render, staticRenderFns } from "./CustomerBankStatement.vue?vue&type=template&id=1d401b73&scoped=true"
import script from "./CustomerBankStatement.vue?vue&type=script&lang=js"
export * from "./CustomerBankStatement.vue?vue&type=script&lang=js"
import style0 from "./CustomerBankStatement.vue?vue&type=style&index=0&id=1d401b73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d401b73",
  null
  
)

export default component.exports